export const DISCOUNTS = 'api/v2/discounts/for-parent';
